import { roleHook } from '@whistler-ui/k2/factories';
import { useMemo } from 'react';

import { ROLES } from '../constants';
import { useAuthStore } from '../store';

export const useRoleKeeper = () => {
  const {
    authValues: { loggedUser },
  } = useAuthStore();

  const PERMISSIONS = {
    'access-default-actions': [ROLES.ADMINISTRATOR, ROLES.DEVELOPER],
    'access-to-my-team': [ROLES.ADMINISTRATOR],
    'access-to-reports': [
      ROLES.ADMINISTRATOR,
      ROLES.DEVELOPER,
      ROLES.SUPPORT,
      ROLES.FINANCE,
      ROLES.PARTNER_CARRIER,
    ],
    'access-to-billing': [ROLES.ADMINISTRATOR, ROLES.FINANCE],
    'access-to-devices': [ROLES.ADMINISTRATOR, ROLES.DEVELOPER, ROLES.SUPPORT],
    'access-to-support': [ROLES.ADMINISTRATOR, ROLES.DEVELOPER, ROLES.SUPPORT],
    'access-to-upgrade': [ROLES.ADMINISTRATOR, ROLES.FINANCE],
    'approve-nsx-settings': [ROLES.ADMINISTRATOR],
    // GET /rcs/cognito/client-secret is ADMINISTRATOR-scoped (UES-12629).
    'read-rcs-client-secret': [ROLES.ADMINISTRATOR],
  };

  return useMemo(() => {
    if (!loggedUser) {
      return [() => false, () => null];
    }

    return roleHook({
      currentRoles: loggedUser.roles,
      permissions: PERMISSIONS,
    });
  }, [loggedUser]);
};
